import React from 'react';

export default Text = props => {
    return(
        <span className={props.className}>
            {props.children}
        </span>
    )
}